import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { TotalSales } from './types';
import { getBaseUrlV2, getDateRangeForApiCall } from '../utils';

export const getTotalSalesForEntity = ({
  entityType,
  entityId,
  interval,
}: {
  entityType: EntityType;
  entityId: string;
  interval: Interval;
}) => {
  const baseUrl = getBaseUrlV2(entityType, entityId);
  return merchantGatewayApi
    .get<TotalSales>(`${baseUrl}/total-sales`, { params: getDateRangeForApiCall(interval) })
    .then(response => response.data);
};
